import { Toast } from 'vant'
import { goUserRegister, queryStudentGetCode, checkUserStudent } from '@/api'
export default {
  components: {},
  props: [],
  name: 'login-page',
  data () {
    return {
      user: {
        realName: null,
        idCard: null,
        phone: null,
        code: null,
        password: null,
        isChina: true
      },
      newPassword: null,
      timeNum: null,
      isBindWX: null,
      isShow: false,
      havePhone: null,
      xphone: null,
      timer: null,
      timer1: null
    }
  },
  computed: {
  },
  watch: {
  },
  created () { },
  mounted () { },
  destroyed () { },
  methods: {
    // 检测是否已经注册
    async getcheckUserStudent () {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        if (!this.user.realName || !this.user.idCard) {
          if (!this.user.realName) { Toast({ message: '请输入用户名', type: 'fail' }); return }
          if (!this.user.idCard) { Toast({ message: '请输入识别号信息', type: 'fail' }); return }
          return
        }
        const { data, error } = await checkUserStudent({ idCard: this.user.idCard, name: this.user.realName })
        if (error.returnCode === 0) {
          if (JSON.stringify(data) !== '{}') {
            this.isBindWX = data.isBindWX
            this.isShow = true
            this.havePhone = data.codePhone
            this.xphone = data.showPhone
          }
        }
      }, 800)
    },
    async loginBtnClicked () { // 非静默授权，第一次有弹框
      if (!this.isShow) {
        await this.getcheckUserStudent()
      } else {
        var reg = /[@#$%^&*]+/g
        if (!this.user.realName) { Toast({ message: '请输入用户名', type: 'fail' }); return }
        if (!this.user.idCard) { Toast({ message: '请输入识别号信息', type: 'fail' }); return }
        if (reg.test(this.user.idCard)) {
          Toast({ message: '识别号输入有误', type: 'fail' })
          return
        }
        if (!this.user.phone && !this.isBindWX) { Toast({ message: '请输入手机号', type: 'fail' }); return }
        if (!this.user.code && !this.isBindWX) {
          Toast({ message: '验证码输入有误', type: 'fail' }); return
        }
        if (!this.user.password) { Toast({ message: '请输入密码', type: 'fail' }); return }
        const { data, error } = await goUserRegister(this.user)
        if (data && error.returnCode === 0) {
          this.$router.push({ path: '/' })
        } else {
          Toast({ message: error.returnMessage, type: 'error' })
        }
      }
    },
    // 获取验证码
    async inputVerificationCode (type) {
      clearTimeout(this.timer1)
      this.timer1 = setTimeout(async () => {
        if (!type) {
          Toast({ message: '请输入手机号', type: 'fail' }); return
        }
        this.timeNum = 60
        const { error } = await queryStudentGetCode({ phone: this.user.phone, isChina: this.user.isChina })
        if (error.returnCode === 0) {
          // this.timeNum = 60
          const set = setInterval(() => {
            this.timeNum = --this.timeNum
          }, 1000)
          setTimeout(() => {
            this.timeNum = null
            clearInterval(set)
          }, 60000)
        } else {
          Toast({ message: error.returnMessage, type: 'error' })
          this.timeNum = null
        }
      }, 500)
    },
    forgetPassword () {
      this.$router.push({ path: '/resetPassword', query: { phone: this.havePhone, xphone: this.xphone } })
    }
  }
}
